import { graphql } from 'gatsby';
import Homepage from '../layouts/homepage';

export const pageQuery = graphql`
  query Strapi4Homepage {
    homepage: strapiHomepage {
      content {
        data {
          childMarkdownRemark {
            html
          }
        }
      }

      # HomepageHead
      headPageTitle: page_title
      headMetaTitle: meta_title
      headTitle: title
      headSlug: slug
      headMetaDescription: meta_description
      headImage: image {
        src: url
        height
        width
        localFile {
          childImageSharp {
            gatsbyImageData(
              layout: FIXED
              width: 400
              quality: 80
            )
          }
        }
      }
      # HomepageHead

      ...HomepagePage
    }
  }
`;

export default Homepage;
